<script>
  import { onMount } from "svelte";

  export let id;
  export let number;
  export let winkel_outer = 33.33;
  export let winkel_innen = 60;
  export let text_box_color = "blue";
  export let text_box = "XXX";
  export let source_text = "";
  export let source_color = "#455F51";

  export let radius = 37;
  const donut_size = 12;

  let mounted = false;
  let percentage_text = "";

  onMount(() => {
    draw();
    mounted = true;
  });

  $: {
    winkel_outer, winkel_innen, radius;

    if (mounted && radius) {
      draw();
    }
  }

  function sleep(milliseconds) {
    return new Promise((resolve) => setTimeout(resolve, milliseconds));
  }

  async function draw() {
    await sleep(500);

    var donut_color = "#afcb08";
    var outer_color = "#34473d";
    // var outer_color_border = '#9caaa3';
    var outer_color_border = "#ffffff";
    const canvas = document.getElementById("myCanvas" + number.toString());
    const context = canvas.getContext("2d");
    const centerX = canvas.width / 2;
    const centerY = canvas.height / 2;

    var radius_offset = 3;

    context.clearRect(0, 0, canvas.width, canvas.height);

    draw_text_bereich();

    context.beginPath();
    context.fillStyle = outer_color;
    context.strokeStyle = outer_color_border;
    context.lineWidth = 4;

    context.arc(centerX, centerY, radius, start_on_top(0), start_on_top(percentage_to_einheitskreis(winkel_outer)), false);
    context.lineTo(centerX, centerY);
    context.stroke();
    context.fill();

    context.beginPath();
    context.fillStyle = "#FFFFFF";
    context.strokeStyle = "#FFFFFFFF";
    context.arc(centerX, centerY, radius - radius_offset, start_on_top(0), start_on_top(percentage_to_einheitskreis(100)), false);
    context.fill();

    context.beginPath();
    context.fillStyle = donut_color;
    context.strokeStyle = donut_color;
    context.arc(
      centerX,
      centerY,
      radius - radius_offset - 2,
      start_on_top(0),
      start_on_top(percentage_to_einheitskreis(winkel_innen)),
      false,
    );
    context.lineTo(centerX, centerY);
    context.fill();

    context.beginPath();
    context.fillStyle = "#FFFFFF";
    context.strokeStyle = "#FFFFFF";
    context.arc(
      centerX,
      centerY,
      radius - radius_offset - 2 - donut_size,
      start_on_top(0),
      start_on_top(percentage_to_einheitskreis(100)),
      false,
    );
    context.fill();

    context.stroke();

    context.textBaseline = "middle";
    context.textAlign = "center";

    context.fillStyle = "#595959";
    // context.font = "bold 16px Arial";
    context.font = "16px Arial";
    //context.fillText(winkel_innen.toFixed(0).toString() + '%', canvas.width / 2, canvas.height / 2);

    percentage_text = winkel_innen.toFixed(0).toString() + "%";
  }

  function start_on_top(x) {
    return x - Math.PI / 2;
  }

  function percentage_to_einheitskreis(p) {
    return (2 * Math.PI * p) / 100;
  }

  function draw_text_bereich() {
    return;

    const canvas = document.getElementById("myTextCanvas" + number.toString());
    const context = canvas.getContext("2d");

    context.clearRect(0, 0, canvas.width, canvas.height);

    context.fillStyle = text_box_color;
    context.fillRect(12, 0, canvas.width - 12 * 2, canvas.height);

    context.textBaseline = "middle";
    context.textAlign = "center";
    context.fillStyle = "#FFFFFF";
    // context.font = "bold 16px Arial";
    context.font = "16px Arial";
    // console.log("canvas.width: ", canvas.width)
    // console.log("canvas.height: ", canvas.height)
    context.fillText(text_box, canvas.width / 2, canvas.height / 2);
  }
</script>

<!-- 
<div class="col">
	<div class="row d-flex">
		<canvas id="myCanvas{number}" width="{radius*2 + 20}" height="{radius*2 + 20}"></canvas>
	</div>

	<div class="row">
		<canvas id="myTextCanvas{number}" width="{radius*2}" height="30"></canvas>
	</div>
</div>
 -->

<!-- <div class="col"> -->
<div class="form-group canvas-container">
  <canvas id="myCanvas{number}" width={radius * 2 + 5} height={radius * 2 + 5} style="position: absolute;" />
  <!-- <div style="position: absolute; 
              
              z-index: 2;">
              ein Text
  
  </div> -->
  <div class="overlay">
    {percentage_text}
  </div>
</div>

<div class="form-group canvas-container">
  <canvas id="myTextCanvas{number}" width={radius * 2 + 5} height="25" />
  <div
    class="overlay"
    style="background-color:{text_box_color}; color: white; padding-right:10px; padding-left: 10px; margin-top: {radius *
      2}px; margin-bottom: 25px;"
  >
    <nobr style="font-size: .9rem;">{text_box}</nobr>
  </div>
  <div class="overlay source-text">
    <nobr style="color: {source_color}; margin-top: {radius * 2 + 30}px; padding-bottom:15px;">{source_text}</nobr>
  </div>
</div>

<!-- <div>
  Mein unterer Text
  </div> -->

<!-- </div> -->

<!-- <canvas id="myTextCanvas{number}" width="50" height="30" /> -->
<style>
  .canvas-container {
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .container canvas,
  .overlay {
    position: absolute;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .overlay {
    z-index: 2;
  }

  .source-text {
    font-size: 10px;
  }
</style>
